import { render } from "./PlaylistCreateComponent.vue?vue&type=template&id=20495ff0&scoped=true"
import script from "./PlaylistCreateComponent.vue?vue&type=script&lang=js"
export * from "./PlaylistCreateComponent.vue?vue&type=script&lang=js"

import "./PlaylistCreateComponent.vue?vue&type=style&index=0&id=20495ff0&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20495ff0"]])

export default __exports__